import React from 'react';

const Wyoming = () => (
  <svg
    width="94"
    height="77"
    viewBox="0 0 94 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.5976 9.59975C91.3729 31.4406 90.7253 54.8515 88.4795 76.6712C58.228 74.4956 28.934 71.3695 0.942383 66.9407C3.46275 51.5001 5.65223 34.2851 8.10924 17.2814C8.47532 14.7537 9.27087 12.233 9.64399 9.59975C10.0946 6.42431 9.46095 2.94612 11.6927 0.897217C14.91 1.19293 22.5486 2.1857 28.0751 2.94612C45.6684 5.3541 65.4864 7.68463 83.8752 9.09281C87.0996 9.3322 90.3732 9.74761 93.5976 9.59975Z"
      fill="#FC374D"
    />
  </svg>
);

export default Wyoming;
